<template lang="pug">
.height-100.p-relative
  div(v-for="item in grupos" :key="item.id")
    .my-2.bg-gray.py-1.px-2.s-rounded(v-if="item.type === 'grupo'") #[b {{ item.descricao }}]
    .columns(v-else)
      .column.col-6.col-sm-12.mb-2(v-for="categoria in item.categorias" :key="categoria.id")
        .panel.py-2.c-hand.hover.categoria.s-rounded(:class="{active: selected && selected.id === categoria.id}" @click="$emit('select', categoria)")
          .panel-body.py-2
            .columns.flex-centered
              .column.col-auto
                img.img-categoria.img-responsive.s-rounded(:src="categoria.icone")
              .column
                | {{ categoria.descricao }}
              .column.col-auto
                i.fa.fa-chevron-right
</template>

<script>
export default {
  props: ['grupos', 'selected'],
}
</script>

<style lang="stylus" scoped>
.categoria
  &.active
    border-color: #575fcf
  .img-categoria
    width: 50px
  
.hover:hover
  background-color: #fafafa

</style>
